import React, { useId, useState } from 'react';
import { BTC_NASDAQ_INTRO, REGIME_ROWS } from '../utils/btcNasdaqSignal';

function BtcNasdaqHelp() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="btc-nasdaq-help">
      <button
        type="button"
        className="btc-nasdaq-help-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        How to read this
      </button>
      {open && (
        <div id={panelId} className="btc-nasdaq-help-panel" role="region" aria-label="BTC vs Nasdaq guide">
          <p className="btc-nasdaq-help-body">{BTC_NASDAQ_INTRO}</p>
          <table className="btc-nasdaq-regime-table">
            <thead>
              <tr>
                <th>Correlation</th>
                <th>Regime</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              {REGIME_ROWS.map((row) => (
                <tr key={row.id}>
                  <td>{row.range}</td>
                  <td>
                    {row.emoji} {row.label}
                  </td>
                  <td>{row.tooltip}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="btc-nasdaq-help-note">
            Log returns on aligned Nasdaq sessions. Auto picks Kraken or the BTC ETP with the
            longest overlap on QQQ days (short Kraken backfills won’t cap the chart if ETP history
            is longer). ETP mode uses daily ETP prices — spot proxy with premium/fees. Kraken mode
            can use 21:00 UTC hourly alignment. 12-week rolling correlation reduces close-time
            noise; Spearman 90d is a robustness check.
          </p>
        </div>
      )}
    </div>
  );
}

export default BtcNasdaqHelp;
